import { useNavigate } from 'react-router-dom'
import { ChevronLeftCircle } from '../icons'
import { Icon } from '.'
import Button from 'components/Button'

const Back = ({
  path = '/account',
  label = 'Back',
  onClick,
  text,
}: {
  path?: string
  label?: string
  onClick?: () => void
  text?: string | null
}) => {
  const navigate = useNavigate()
  const back = () => navigate(path)

  return text ? (
    <Button
      icon={<ChevronLeftCircle size={25} />}
      onClick={onClick || back}
      color="header"
      size="header"
    >
      &nbsp;{text}
    </Button>
  ) : (
    <Icon aria-label={label} margin="0 0 0 -1.25rem" onClick={onClick || back}>
      <ChevronLeftCircle size={25} />
    </Icon>
  )
}

export default Back
